export const auditLogsQueryKeys = {
  all: ['audit-logs'] as const,
  lists: () => [...auditLogsQueryKeys.all, 'list'] as const,
  list: () => [...auditLogsQueryKeys.lists()] as const,
  trail: (resourceId: string) =>
    [...auditLogsQueryKeys.all, 'trail', resourceId] as const,
};
